<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner :background="info.image ? info.image.url : ''" :title="!pgLoading ? $t('app.categories') : ''"
      :subtitle="!pgLoading ? $t('app.categories') : ''">
    </Banner>

    <section class="events-grid-area pt-50 pb-50">
      <div class="container">
        <div v-if="pgLoading" class="row g-5">
          <div v-for="(item, idx) in 6" :key="idx" class="col-xl-4 col-lg-4 col-md-6">
            <div class="events-02 pos-rel mb-30 wow fadeInUp2 animated webkit-animation webkit-none-270"></div>
          </div>
        </div>

        <div v-if="!pgLoading" class="row">
          <div v-for="(row, idx) in categories" :key="idx" v-if="row.projects_no >= 1"
            class="col-xl-4 col-lg-4 col-md-6">
            <router-link :to="{ name: 'show-categories', params: { cat: row.slug } }">
              <div class="events-02 pos-rel mb-30 wow fadeInUp2 animated" data-wow-delay=".2s" :style="row.image
                  ? 'background-image: url(' + row.image.url + ')'
                  : 'background-image: url(/assets/img/logo/min-logo.png)'
                ">
                <div class="events__content">
                  <span>
                    <i class="far fa-hand-holding-heart"></i>
                    {{ row.projects_no }}
                    {{ $t("app.project") }}
                  </span>
                  <h3>
                    <router-link :to="{
                      name: 'show-categories',
                      params: { cat: row.slug },
                    }" style="text-shadow: 1px 0px #777">
                      {{ row.name }}
                    </router-link>
                  </h3>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      //
      locale: "ar",
      pgLoading: true,
      info: "",
      categories: [],

      currentPage: 1,
      itemsPerPage: 9,
      resultCount: 0,
      nextPage: 2,
      prevPage: 0,
    };
  },
  computed: {
    totalPages: function () {
      return Math.ceil(this.resultCount / this.itemsPerPage);
    },
  },
  mounted() { },
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/categories",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 9,
          page: this.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.categories = res.data.rows;

          // info
          this.info = res.data.info;

          // pagination
          this.currentPage = res.data.paginate.current_page;
          //this.itemsPerPage = res.data.paginate.per_page;
          this.resultCount = res.data.paginate.total;
          this.nextPage = res.data.paginate.next_page;
          this.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => { })
        .finally(() => { });
    },

    setPage: function (pageNumber) {
      this.currentPage = pageNumber;
      this.fetchData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
